export default __webpack_public_path__ + "static/media/Schneider-legrand1.30d5412a.png";